import React, { useCallback } from 'react';
import * as slice from "../../store/course/courseSlice";
import * as questionSlice from "../../store/questionBank/questionBankSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { courseActions } from '../../store/course/courseSlice';
import { questionBankActions } from '../../store/questionBank/questionBankSlice';
import { use } from 'react';

export const useCourse = () => {
    const dispatch = useAppDispatch();
    return {
        loadCourses: useCallback((payload) => {
            dispatch(courseActions.loadCourses(payload));
        }, [dispatch]),
        loadCurrent: useCallback((payload) => {
            dispatch(courseActions.loadCurrentCourse(payload));
        }, [dispatch]),
        resetCurrent: useCallback(() => {
            dispatch(courseActions.resetCurrentCourse());
        }, [dispatch]),
        loadCoursesList: useCallback((payload) => {
            dispatch(courseActions.loadCoursesList(payload));
        },[dispatch]),
        loadNextCourse: useCallback((payload) =>{
            dispatch(courseActions.loadNextCourse(payload));
        },[dispatch]),
        resetCoursesList: useCallback((payload) => {
            dispatch(courseActions.resetCoursesList(payload));
        },[dispatch]),
        save: useCallback((payload) => {
            dispatch(courseActions.saveCurrentCourse(payload));
        }, [dispatch]),
        create: useCallback((payload) => {
            dispatch(courseActions.createCourse(payload));
        }, [dispatch]),
        remove: useCallback((payload) => {
            dispatch(courseActions.removeCourse(payload));
        }, [dispatch]),
        savePrerequisites: useCallback((payload) => {
            dispatch(courseActions.savePrequisites(payload));
        }, [dispatch]),
        loadLessonPlan: useCallback((payload) => {
            dispatch(courseActions.loadLessonPlan(payload));
        }, [dispatch]),
        createLessonPlan: useCallback((payload) => {
            dispatch(courseActions.createLessonPlan(payload));
        }, [dispatch]),
        setLessonPlan: useCallback((payload) => {
            dispatch(courseActions.setLessonPlan(payload));
        }, [dispatch]),
        deleteLessonPlan: useCallback((payload) => {
            dispatch(courseActions.deleteLessonPlan(payload));
        }, [dispatch]),
        saveLessonPlan: useCallback((payload) => {
            dispatch(courseActions.saveCurrentLessonPlan(payload));
        }, [dispatch]),
        updateLessonPlan: useCallback((payload) => {
            dispatch(courseActions.updateLessonPlan(payload));
        }, [dispatch]),
        updateSection: useCallback((payload) => {
            dispatch(courseActions.updateSection(payload));
        }, [dispatch]),
        setChapters: useCallback((payload) => {
            dispatch(courseActions.setChapters(payload));
        }, [dispatch]),
        updateChapter: useCallback((payload) => {
            dispatch(courseActions.updateChapter(payload));
        }, [dispatch]),
        updateAssessments: useCallback((payload) => {
            dispatch(courseActions.updateAssessments(payload));
        }, [dispatch]),
        loadQuestions: useCallback((payload) => {
            dispatch(questionBankActions.loadQuestionBank(payload));
        }, [dispatch]),
        createAssessment: useCallback((payload) => {
            dispatch(courseActions.createAssessment(payload));
        }, [dispatch]),
        deleteAssessment: useCallback((payload) => {
            dispatch(courseActions.deleteAssessment(payload));
        }, [dispatch]),
        loadCurrentAssessment: useCallback((payload) => {
            dispatch(courseActions.loadCurrentAssessment(payload));
        }, [dispatch]),
        updateAssessment: useCallback((payload) => {
            dispatch(courseActions.saveCurrentAssessment(payload));
        }, [dispatch]),
        publishAssessmentChapterToLessonPlan: useCallback((payload) => {
            dispatch(courseActions.publishAssessmentChapterToLessonPlan(payload));
        }, [dispatch]),
        publishAssessmentSectionToLessonPlan: useCallback((payload) => {
            dispatch(courseActions.publishAssessmentSectionToLessonPlan(payload));
        }, [dispatch]),
        publishAssessmentToCourse: useCallback((payload) => {
            dispatch(courseActions.publishAssessmentToCourse(payload));
        }, [dispatch]),
        setCurrentSession: useCallback((payload) => {
            dispatch(courseActions.setCurrentSession(payload));
        }, [dispatch]),
        setCurrentChapter: useCallback((payload) => {
            dispatch(courseActions.setCurrentChapter(payload));
        }, [dispatch]),
        setCurrentCourseCompleted: useCallback((payload) => {
            dispatch(courseActions.setCurrentCourseComplete(payload));
        }, [dispatch]),
        setLastSection: useCallback((payload) => {
            dispatch(courseActions.setLastSection(payload))
        }, [dispatch]),
        setLastChapter: useCallback((payload) => {
            dispatch(courseActions.setLastChapter(payload))
        }, [dispatch]),
        setNextCourse: useCallback((payload) => {
            dispatch(courseActions.setNextCourse(payload))
        }, [dispatch]),
        setAllCourseComplete: useCallback((payload) => {
            dispatch(courseActions.setAllCourseComplete(payload))
        }, [dispatch]),
        // loadGeneratedQuestions: useCallback((payload)=>{
        //     dispatch(courseActions.loadGeneratedQuestions(payload))
        // },[dispatch]),

        
        courses: useAppSelector(slice.getCourses),
        courseList : useAppSelector(slice.getCourseList),
        diagnosticList: useAppSelector(slice.getDiagnosticList),
        allCourseList : useAppSelector(slice.getAllCourseList),
        lastPage: useAppSelector(slice.getLastPage),
        lessonPlan: useAppSelector(slice.getLessonPlan),
        current: useAppSelector(slice.getCurrentCourse),
        currentAssessment:useAppSelector(slice.getCurrentAssessment),
        loading: useAppSelector(slice.isLoading),
        pagination: useAppSelector(slice.getPagination),
        questionsList: useAppSelector(questionSlice.getQuestionBank),
        currentChapter: useAppSelector(slice.getChapter),
        currentSession: useAppSelector(slice.getSession),
        currentCourseComplete: useAppSelector(slice.isCurrentCourseComplete),
        nextCourse: useAppSelector(slice.getNextCourse),
        lastSectionChapter: useAppSelector(slice.getLastSectionChapter),
        allCourseComplete: useAppSelector(slice.isAllCourseComplete),
        // generatedQuestions: useAppSelector(slice.getGeneratedQuestions),
    }
}